import { ComponentType } from "react";

export interface CategorySectionProps<T> {
    /**
     * category id
     */
    categoryId?: number;

    /**
     * active prop is not really used
     * it just to make sure that component is re-rendered
     * when section becomes active
     * to cause truncate markup to calculate
     * lines height again.
     */
    active?: boolean;
    content: T;
    additionalParams?: Record<string, unknown>;
}
export enum SectionIndex {
    SESSIONS = 1,
    MEDIA = 2,
    /*
     * "Playlists" and "Channels" tabs intentionally have the same index.
     * "Playlists" appears only on the channel page, "Channels" appears only on the gallery page.
     * They are destined to never meet each other.
     */
    PLAYLISTS = 3,
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    CHANNELS = 3,
    LEARN_MORE = 4,
}

export interface CategorySection<T = any> {
    content: T;
    name: string;
    component: ComponentType<T>;
    index: SectionIndex;
    additionalParams?: Record<string, unknown>;
}

export type BoardMessage = {
    id: number;
    message: string;
    allowDismiss: boolean;
};
